import React from 'react';
import { GraduationCap, Award, ArrowRight, CheckCircle2 } from 'lucide-react';
import { cambridgeContent } from '../mock';

const Cambridge = () => {
  const c = cambridgeContent;
  return (
    <section id="cambridge" className="bg-[#FAF6EC] py-20 md:py-24 relative overflow-hidden">
      {/* Decorative dots */}
      <div className="absolute top-16 left-10 grid grid-cols-6 gap-1.5 opacity-25">
        {Array.from({ length: 24 }).map((_, i) => (
          <span key={i} className="w-1 h-1 rounded-full bg-[#B08D3C]" />
        ))}
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          <div>
            <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-widest text-[#9B2C3B] px-3 py-1.5 bg-white border border-[#9B2C3B]/30 rounded-full">
              <Award className="h-3.5 w-3.5" />
              {c.eyebrow}
            </span>
            <h2 className="mt-5 font-serif text-4xl md:text-5xl leading-[1.05] font-bold text-[#1E3A5F]">
              {c.title}{' '}
              <span className="text-[#9B2C3B] italic">{c.titleHighlight}</span>
            </h2>
            <p className="mt-6 text-[15px] text-[#1E3A5F]/75 leading-relaxed max-w-lg">
              {c.description}
            </p>

            <div className="mt-8 grid grid-cols-3 gap-3">
              {c.stats.map((s, i) => {
                const bgs = ['#E8B84A', '#5B84A6', '#9B2C3B'];
                const txts = ['#1E3A5F', '#FFFFFF', '#FFFFFF'];
                return (
                  <div
                    key={s.label}
                    className="rounded-2xl p-4 text-center shadow-sm"
                    style={{ backgroundColor: bgs[i], color: txts[i] }}
                  >
                    <div className="font-serif text-3xl font-bold">{s.value}</div>
                    <div className="text-[11px] opacity-90 mt-1 leading-tight">
                      {s.label}
                    </div>
                  </div>
                );
              })}
            </div>

            <a
              href="#contacto"
              className="mt-8 inline-flex items-center gap-2 bg-[#1E3A5F] hover:bg-[#15294A] text-white text-[14px] font-semibold px-6 py-3.5 rounded-full transition-colors"
            >
              {c.cta}
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>

          <div className="relative">
            <div className="bg-[#1E3A5F] rounded-t-3xl px-6 py-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="h-10 w-10 rounded-full bg-[#E8B84A] flex items-center justify-center">
                  <GraduationCap className="h-5 w-5 text-[#1E3A5F]" />
                </span>
                <div>
                  <div className="text-[10px] font-bold tracking-widest text-[#E8B84A]">
                    WE PREPARE FOR
                  </div>
                  <div className="font-serif text-white text-xl font-bold">
                    Cambridge English
                  </div>
                </div>
              </div>
              <span className="text-[10px] text-white/70 font-medium">
                Qualifications
              </span>
            </div>

            <div className="bg-white border border-t-0 border-[#1E3A5F]/10 rounded-b-3xl divide-y divide-[#1E3A5F]/8 shadow-lg">
              {c.levels.map((lvl) => (
                <div
                  key={lvl.code}
                  className="flex items-center gap-4 px-6 py-4 hover:bg-[#FAF6EC]/70 transition-colors group cursor-default"
                >
                  <div className="h-10 w-10 rounded-full bg-[#E8B84A] flex items-center justify-center flex-shrink-0">
                    <span className="font-serif text-[13px] font-bold text-[#1E3A5F]">
                      {lvl.code}
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-serif text-[17px] font-bold text-[#1E3A5F]">
                      {lvl.name}
                    </div>
                    <div className="text-[12px] text-[#1E3A5F]/60">{lvl.desc}</div>
                  </div>
                  <CheckCircle2 className="h-5 w-5 text-[#9B2C3B] opacity-80 group-hover:opacity-100 transition-opacity" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cambridge;
